import React from 'react'
import styled from 'styled-components'
import { Box } from '@sketch/components'

import { useVersioning } from '../../ShareVersionContext'
import { ShareVersionsItem } from '../ShareVersions/ShareVersionsItem'

import { useGetLatestStarQuery } from '@sketch/gql-types'

const Separator = styled.div`
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.A};
  margin-left: 16px;
  margin-top: 4px;
`

export const LatestStar = ({ latestStar }: { latestStar?: any }) => {
  const { share, versionShortId, latestVersion } = useVersioning()
  const shareIdentifier = share?.identifier

  const { data, error } = useGetLatestStarQuery({
    variables: { shareIdentifier },
    skip: !shareIdentifier || latestStar,
  })

  const latestStarToShow = latestStar ?? data?.share?.version

  if (
    !shareIdentifier ||
    !latestStarToShow ||
    error ||
    latestStarToShow.kind !== 'PUBLISHED' ||
    !versionShortId ||
    !share
  ) {
    return null
  }

  return (
    <Box mt={1}>
      <ShareVersionsItem
        key={latestStar.identifier}
        version={latestStar}
        share={share}
        isLatestVersion={latestStar.identifier === latestVersion.identifier}
        isLatestStared
        isSingleVersion
        hideDescription
        isVersionSelected={latestStar.shortId === versionShortId}
      />
      <Separator />
    </Box>
  )
}
